export const CURRENT_ASSET_GROUP_REFRESH_RESULT = 'mediagraph:currentAssetGroupRefreshResult';

export const waitForCurrentAssetGroupRefresh = (requestId, {timeout = 30_000} = {}) => new Promise((resolve, reject) => {
    let timeoutId;
    const cleanup = () => {
        clearTimeout(timeoutId);
        window.removeEventListener(CURRENT_ASSET_GROUP_REFRESH_RESULT, onResult);
    };
    const onResult = event => {
        if (event.detail?.requestId !== requestId) return;
        cleanup();
        if (event.detail?.error) reject(event.detail.error);
        else resolve({canceled: Boolean(event.detail?.canceled)});
    };

    window.addEventListener(CURRENT_ASSET_GROUP_REFRESH_RESULT, onResult);
    timeoutId = setTimeout(() => {
        cleanup();
        reject(new Error('The current library view did not finish refreshing'));
    }, timeout);
});

export const finishCurrentAssetGroupRefresh = (requestId, {error = null, canceled = false} = {}) => {
    if (!requestId) return;
    window.dispatchEvent(new CustomEvent(CURRENT_ASSET_GROUP_REFRESH_RESULT, {
        detail: {requestId, error, canceled},
    }));
};
